import { Component, inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EstadosDocumentoComponent } from '../../commons/estados-documento/estados-documento.component';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ListadoDocumentoPaginado, Documento } from '../../models/Document';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppTitleService } from '../../services/app-title.service';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentoService } from '../../services/documento.service';
import { ReportService } from '../../services/report.service';
import { catchError, EMPTY, map, merge, startWith, switchMap } from 'rxjs';
import { FilterData } from '../borrador/borrador.component';
import { DocumentType } from '../../models/DocumentType';
import { NoDataFoundComponent } from "../../commons/no-data-found/no-data-found.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AutofocusDirective } from '../../helpers/autofocus.directive';
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../commons/dlg-confirm/dlg-confirm.component';
import { DlgAlertComponent } from '../../commons/dlg-alert/dlg-alert.component';
import { TareaService } from '../../services/tarea.service';
import { DeprecatedComponent } from "../../commons/deprecated/deprecated.component";

@Component({
    selector: 'app-bandeja-reasignados',
    imports: [
    MatTableModule, MatPaginatorModule, MatSortModule,
    MatSnackBarModule,
    MatToolbarModule, MatButtonModule, MatIconModule,
    MatInputModule, MatFormFieldModule,
    FormsModule, ReactiveFormsModule,
    MatSelectModule, AutofocusDirective,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressBarModule,
    EstadosDocumentoComponent,
    NoDataFoundComponent,
    DeprecatedComponent
],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    templateUrl: './bandeja-reasignados.component.html',
    styleUrl: './bandeja-reasignados.component.scss'
})
export class BandejaReasignadosComponent {
  deprecated = true;

  displayedColumns: string[] = ['select', 'estados', 'asunto', 'fecha', 'numeroDocumento'];
  documentsPaginated: ListadoDocumentoPaginado | undefined
  dataSource = new MatTableDataSource<Documento>([]);
  selection = new SelectionModel<Documento>(true, []);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  resultsLength = 0;
  isLoadingResults = true;

  documentTypes: DocumentType[] | undefined

  dateRangeInWeeks = 5
  initialDate = "2025-01-02"
  maxDate = new Date()

  snackbarData: ScnackbarData = {}

  filterForm = new FormGroup({
    fechaInicio: new FormControl(new Date(), {
      validators: [
        Validators.required
      ]
    }),
    fechaFin: new FormControl(new Date(), {
      validators: [
        Validators.required,
      ]
    }),
    searchText: new FormControl(""),
    documentType: new FormControl("")
  })

  constructor(
    private documentoSrv: DocumentoService,
    private documentTypeService: DocumentTypeService,
    private router: Router,
    private reportService: ReportService,
    public dialog: MatDialog,
    public dlg: MatDialog,
    private toast: ToastService,
    private tareaService: TareaService,
    private dateService: DateService
  ) {
    inject(AppTitleService).setTitle("Reasignados");
  }

  ngOnInit(): void {
    const currentDate = new Date()
    let initialDate = new Date(this.initialDate)
    //initialDate.setDate(currentDate.getDate() - this.dateRangeInWeeks * 7)
    this.filterForm.controls.fechaFin.setValue(currentDate)
    this.filterForm.controls.fechaInicio.setValue(initialDate)
  }

  ngAfterViewInit(): void {
    const label = document.getElementById(this.paginator._pageSizeLabelId)
    label!.textContent = "Items por p\xe1gina"

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.documentTypeService.list().subscribe({
      next: (response: DocumentType[]) => {
        this.documentTypes = response;
        let documentTypeDescription = "Oficio"

        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);

        if (defaultType) {
          this.filterForm.controls.documentType.setValue("-1")

          merge(this.sort.sortChange, this.paginator.page).pipe(
            startWith({}),
            switchMap(() => {
              this.isLoadingResults = true;
              const filterData = this.createFilterData()
              return this.documentoSrv!.getListadoDocumentosReasignados(
                filterData.initialDate,
                filterData.endDate,
                filterData.searchText,
                filterData.documentType,
                this.paginator.pageIndex + 1,
              ).pipe(catchError(() => EMPTY));
            }),
            map(data => {
              this.isLoadingResults = false;
              if (data === null) {
                return [];
              }
              this.resultsLength = data.totalDocumentos;
              return data;
            })
          ).subscribe({
            next: (response) => {
              this.documentsPaginated = response as ListadoDocumentoPaginado
              this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)

              Object.keys(this.filterForm.controls).forEach(controlName => {
                if (controlName !== "searchText") {
                  this.filterForm.get(controlName)?.valueChanges.subscribe(_ => {
                    this.onControlValueChanged();
                  });
                }
              });
            }
          })
        }
      }
    });
  }

  onKeyUp(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.onControlValueChanged();
  }

  onControlValueChanged(): void {
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource()
  }

  reload() {
    this.selection.clear()
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  fectchAndInitializeDataSource() {
    this.paginator.pageIndex = 0
    const filterData = this.createFilterData()
    this.isLoadingResults = true;
    this.documentoSrv!.getListadoDocumentosReasignados(
      filterData.initialDate,
      filterData.endDate,
      filterData.searchText,
      filterData.documentType,
      this.paginator.pageIndex + 1,
    ).subscribe({
      next: (response) => {
        this.documentsPaginated = response as ListadoDocumentoPaginado
        this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
        this.resultsLength = this.documentsPaginated.totalDocumentos;
        this.isLoadingResults = false;
      }
    })
  }

  onInformar() { }

  onComentar() { }

  onRecuperar() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("documento/recuperar", { state: taskData })
  }

  onUnprint() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const printed = this.selection.selected.filter(document => document.impresa === 1)
    if (printed.length === 0) {
      this.snackbarData.message = "Las tareas seleccionadas no tienen el estado \"Hoja gu\xeda impresa\""
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: printed.map(document => document.idTarea)
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "50vw",
      width: "450px",
      data: {
        title: "Hoja gu\xeda",
        message: "¿Desea cambiar el estado a \"No impreso\" de las tareas seleccionadas?",
        confirmLabel: "S\xed, cambiar",
        closeLabel: "No"
      }
    })
    const ids = taskData.documentIDs.join(",")
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.tareaService.updateEstadoTareasHojaGuia(0, ids).subscribe({
          next: (res: any) => {
            this.snackbarData.message = "Cambio de estado a \"No impreso\" exitoso"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "success"
            this.toast.show(this.snackbarData)
            this.reload()
          }
        })
      }
    })
  }

  clickedRow(row: Documento) {
    this.router.navigateByUrl("/resumen/" + row.idTarea)
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource!.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource!.data);
  }

  checkboxLabel(row?: Documento): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  private createFilterData(): FilterData {
    const filterData: FilterData = {
      initialDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaInicio.value!),
      endDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaFin.value!),
      documentType: parseInt(this.filterForm.controls.documentType.value!),
      searchText: this.filterForm.controls.searchText.value!
    }
    return filterData
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

  onHojaGuia() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.title = "Selecci\xf3n"
      this.snackbarData.message = "Seleccione al menos un registro"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }

    const unprinted = this.selection.selected.filter(document => document.impresa === 0)
    if (unprinted.length === 0) {
      this.snackbarData.message = "Las tareas seleccionadas tienen el estado \"Hoja gu\xeda impresa\""
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }

    const tareasIDs = unprinted.map(document => document.idTarea);
    var tareas: any = [];
    tareasIDs.forEach((id) => {
      tareas.push({
        id: id,
        comentario: null,
        idParticipante: null,
        fechaExpira: null,
      });
    })
    this.tareaService.getHojaGuia(tareas, 3).subscribe({
      next: (res: any) => {
        if (res) {
          if (res.ids.length > 0) {
            res.fi = this.dateService.formatDateToCustomStringNoTime(this.filterForm.controls.fechaInicio.value!)
            res.ff = this.dateService.formatDateToCustomStringNoTime(this.filterForm.controls.fechaFin.value!)
            res.usr = res.user
            res.ids = tareasIDs.toString()
            this.onCallReport(res);
            this.onCambiarEstadoImpresoConfirm(res)
          } else {
            this.snackbarData.message = "No dispone de documentos o tareas pendientes de impresi\xf3n"
            this.snackbarData.style = SnackbarStyles.Info
            this.snackbarData.iconName = "info"
            this.toast.show(this.snackbarData)
          }
        }
      }
    })
  }

  onCambiarEstadoImpresoConfirm(obj: any) {
    const data: DlgConfirmComponentData = {
      title: "Actualizar estado?",
      message: "¿Desea cambiar el estado impreso de las tareas mostradas?",
      confirmLabel: "S\xed, cambiar",
      closeLabel: "No"
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: data
    })
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.tareaService.updateEstadoTareasHojaGuia(1, obj.ids).subscribe({
          next: (res: any) => {
            this.snackbarData.title = "Tareas impresas"
            this.snackbarData.message = "Estado impreso modificado correctamente"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "success"
            this.toast.show(this.snackbarData)
            this.reload()
          }
        })
      }
    });
  }

  onCallReport(obj: any) {
    var params = {
      P_USUARIO: obj.usr,
      P_DEPARTAMENTO: obj.dpto,
      P_FECHA_INICIO: obj.fi,
      P_FECHA_FIN: obj.ff,
      P_CODIGOS: obj.ids
    }
    var url: any = this.reportService.getUrl("rpListadoHojaGuiaReasigna", params);
    this.reportService.openReport(url as string, 'Listado_hoja_guia_reasignados.pdf');
  }

}
